import { Routes } from '@angular/router';
import { EditInteractionComponent } from './pages/edit-interaction/edit-interaction.component';
import { ListeInteractionsComponent } from './pages/liste-interactions/liste-interactions.component';

export const INTERACTIONS_ROUTE_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP'],
    menu: {
        libelle: 'menu.administration-interactions',
        icon: 'key'
    }
};

export const INTERACTIONS_ROUTES: Routes = [
    { path: '', component: ListeInteractionsComponent },
    { path: 'new', component: EditInteractionComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new/contact/:idc', component: EditInteractionComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new/entreprise/:ide', component: EditInteractionComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditInteractionComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id/contact/:idc', component: EditInteractionComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id/entreprise/:ide', component: EditInteractionComponent, data: { roles: ['ORGANISME'] } }
];
